import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Trends',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: {
                    '++': [
                      {
                        '??': [
                          {
                            '@$': 'financialVolume',
                          },
                          ' ',
                        ],
                      },
                      ' Performance',
                    ],
                  },
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: {
                            '++': [
                              {
                                '??': [
                                  {
                                    '@$': 'financialVolume',
                                  },
                                  ' ',
                                ],
                              },
                              ' Performance',
                            ],
                          },
                          points: {
                            '@': 'barchartPoints',
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          navigationId: 'trends',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    shouldAnalyze: true,
  },
  subqueries: {
    barchartPoints: {
      target: [
        ['2020-01-01', '2020-12-31'],
        ['2021-01-01', '2021-12-31'],
        ['2022-01-01', '2022-12-31'],
        ['2023-01-01', '2023-12-31'],
        ['2024-01-01', '2024-12-31'],
      ],
      selection: {
        '{}': {
          x: {
            if: [
              [
                {
                  '=': [{ '@$': '$period' }, '[2020-01-01,2021-01-01)'],
                },
                '2020',
              ],
              [
                {
                  '=': [{ '@$': '$period' }, '[2021-01-01,2022-01-01)'],
                },
                '2021',
              ],
              [
                {
                  '=': [{ '@$': '$period' }, '[2022-01-01,2023-01-01)'],
                },
                '2022',
              ],
              [
                {
                  '=': [{ '@$': '$period' }, '[2023-01-01,2024-01-01)'],
                },
                '2023',
              ],
              [
                {
                  '=': [{ '@$': '$period' }, '[2024-01-01,2025-01-01)'],
                },
                '2024',
              ],
            ],
          },
          y: {
            '+': {
              '@': 'glExpenses',
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        true,
                      ],
                    },
                    {
                      '=': [
                        {
                          '@': 'expenseOrgShouldAnalyze',
                        },
                        true,
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
            expenseOrgShouldAnalyze: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@': 'organizationShouldAnalyze',
              },
              subqueries: {
                organizationShouldAnalyze: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!org',
                  },
                  target: 'ent:!org:!dept',
                  selection: {
                    '@.': '!should_analyze',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
